import { FormControlLabel, FormGroup, Switch } from '@mui/material'
import React, { ReactElement } from 'react'
type IToggleSwitchProps = {
  checked: boolean
  label: string | ReactElement
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | 'default'
  size?: 'small' | 'medium'
  handleChange: Function
}
export const ToggleSwitch: React.FC<IToggleSwitchProps> = ({
  checked,
  color,
  size,
  label,
  handleChange,
}) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleChange(event.target.checked)
            }
            color={color ? color : 'primary'}
            size={size || 'medium'}
          />
        }
        label={label}
      />
    </FormGroup>
  )
}
